import React, { memo } from "react";
import { JSONViewer } from "react-json-editor-viewer";

const styles = {
  root: {
    margin: "5rem",
    fontSize: "var(--body-text-size)",
    fontFamily: "monospace",
  },
  builtin: {
    color: "var(--primary-text-color)",
  },
  text: {
    color: "var(--positive-color)",
  },
  number: {
    color: "var(--primary-color)",
  },
  property: {
    color: "var(--negative-color)",
  },
  collapseIcon: {
    cursor: "pointer",
  },
};

function PlatformJSONViewer(props) {
  return <JSONViewer data={props.data} collapsible={props.collapsible || true} styles={styles} />;
}

export default memo(PlatformJSONViewer);
